/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Web_Page_ForbiddenInputs */

const en_conversion_error_web_page_forbidden = /** @type {(inputs: Conversion_Error_Web_Page_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to access this web page.`)
};

const es_conversion_error_web_page_forbidden = /** @type {(inputs: Conversion_Error_Web_Page_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede acceder a esta página web.`)
};

/**
* | output |
* | --- |
* | "Unable to access this web page." |
*
* @param {Conversion_Error_Web_Page_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_web_page_forbidden = /** @type {((inputs?: Conversion_Error_Web_Page_ForbiddenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Web_Page_ForbiddenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_web_page_forbidden(inputs)
	return en_conversion_error_web_page_forbidden(inputs)
});